import { Profiles } from '@komi-app/profiles-sdk'
import config from '../config/config'

export const profiles = new Profiles({
  authUrl: config.auth.url,
  targetUrl: config.profiles.gatewayUrl,
  serviceName: config.service.name,
  serviceVersion: config.service.version
})
